import { useSyncExternalStore } from 'react'

const HIDE_DURATION_MS = 10_000

/** Whether the environment ribbon is hidden, shared so dev-only tools can hide along with it (e.g. for screenshots). */
let hidden = false
let showTimeoutId: number | undefined = undefined
const listeners = new Set<() => void>()

/** Hides the ribbon for a few seconds; the timer lives here so that unmounting the ribbon cannot cancel it. */
export function hideEnvironmentRibbonTemporarily(): void {
  window.clearTimeout(showTimeoutId)
  setHidden(true)
  showTimeoutId = window.setTimeout(() => setHidden(false), HIDE_DURATION_MS)
}

export function useEnvironmentRibbonHidden(): boolean {
  return useSyncExternalStore(subscribe, () => hidden)
}

function setHidden(newHidden: boolean): void {
  hidden = newHidden
  for (const listener of listeners) listener()
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
